/* Price match slide-out
 * Shows a small slide-out after a delay (data-delay, seconds).
 * If data-require-engagement="true" it also waits for one sign of hesitation:
 *   - 2+ option changes in the product form, or
 *   - the visitor switches tab and comes back (often checking a competitor).
 * Never shows if: already shown this session, the visitor has added to basket,
 * or has already opened the price match modal.
 * Clicking it opens the existing #PriceMatchModal via [data-price-match-open].
 */
(function () {
  var el = document.querySelector('[data-pm-slideout]');
  if (!el) return;
  // Move to <body> so fixed positioning isn't affected by hidden or transformed parents
  document.body.appendChild(el);

  var SEEN_KEY = 'pm_slideout_seen';
  var BLOCK_KEY = 'pm_slideout_block'; // set after add-to-basket or modal opened
  var delay = (parseInt(el.dataset.delay, 10) || 45) * 1000;
  var needEngagement = el.dataset.requireEngagement === 'true';

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  if (store(SEEN_KEY) || store(BLOCK_KEY)) return;

  var timeUp = false;
  var engaged = !needEngagement;
  var optionChanges = 0;
  var shown = false;
  var blocked = false;

  function block() { blocked = true; store(BLOCK_KEY, '1'); hide(); }

  function modalOpen() {
    var m = document.getElementById('PriceMatchModal');
    return m && m.classList.contains('is-visible');
  }

  function maybeShow() {
    if (shown || blocked || !timeUp || !engaged || modalOpen()) return;
    shown = true;
    store(SEEN_KEY, '1');
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
  }

  function hide() {
    el.classList.remove('is-visible');
    setTimeout(function () { el.hidden = true; }, 300);
  }

  // Timer
  setTimeout(function () { timeUp = true; maybeShow(); }, delay);

  // Engagement: option changes in the add-to-basket form
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('change', function () {
      optionChanges++;
      if (optionChanges >= 2) { engaged = true; maybeShow(); }
    });
    // Added to basket: never show this session
    form.addEventListener('submit', block);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.btn-add-to-cart, [name="add"]')) block();
  }, true);

  // Engagement: left the tab and came back
  var leftAt = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { leftAt = Date.now(); return; }
    if (leftAt && Date.now() - leftAt > 5000) { engaged = true; maybeShow(); }
  });

  // Any price match opener clicked (strip, block, or this slide-out): hide and don't show again
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-price-match-open]')) {
      block();
    }
  });

  // Dismiss
  el.querySelector('[data-pm-slideout-dismiss]').addEventListener('click', hide);
})();
